import styles from "./NotificationSteps.module.scss";

/** How to add Planny to the iPhone/iPad Home Screen — the only way to get notifications there. */
export const IosInstallSteps = () => (
  <ol className={styles.steps}>
    <li>
      <span>
        Докоснете <b>„Сподели“</b> в Safari
      </span>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3v12M8 7l4-4 4 4" />
        <path d="M6 11v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8" />
      </svg>
    </li>
    <li>
      <span>
        Изберете <b>„Към началния екран“</b>
      </span>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="4" y="4" width="16" height="16" rx="4" />
        <path d="M12 8v8M8 12h8" />
      </svg>
    </li>
    <li>
      <span>Отворете Planny от иконата и включете известията</span>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M18 16v-5a6 6 0 0 0-12 0v5l-1.5 2h15L18 16Z" />
        <path d="M10 20.5a2 2 0 0 0 4 0" />
      </svg>
    </li>
  </ol>
);
